export default __webpack_public_path__ + "static/media/wyoming.c68e13a9.jpg";